import React from "react";
import ArrowBackIosNewIcon from "@mui/icons-material/ArrowBackIosNew";
import AppButton from "../../UI/AppButtons";
import { GretaHeaderProps } from "../../../@types/DTO/Booking";

const GretaHeader: React.FC<GretaHeaderProps> = ({
  title,
  fontFamilyStyle,
  totalPrice,
  currency,
  onBack,
  onPriceDetailClick,
  translate,
  showContinueButton = false,
  formId,
  onContinue,
  isSaving = false,
  continueButtonStyle,
  priceDetailsText,
}) => {
  return (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        padding: "16px",
        borderBottom: "1px solid #e0e0e0",
        flexWrap: "wrap",
        gap: "12px",
        position: "sticky",
        top: 0,
        zIndex: 50,
        backgroundColor: "#f5f5f5",
      }}
    >
      {/* Left: back arrow + title */}
      <div
        style={{ display: "flex", alignItems: "center", gap: "12px", flex: 1 }}
      >
        <button
          type="button"
          onClick={onBack}
          style={{
            background: "none",
            border: "none",
            cursor: "pointer",
            padding: "4px",
            display: "flex",
            alignItems: "center",
          }}
        >
          <ArrowBackIosNewIcon style={{ fontSize: "20px", color: "#111" }} />
        </button>
        <h1
          style={{
            fontFamily: fontFamilyStyle,
            fontWeight: "900",
            fontSize: "clamp(18px, 3vw, 28px)",
            color: "#111",
            margin: 0,
            letterSpacing: "0.5px",
            textTransform: "uppercase",
          }}
        >
          {title}
        </h1>
      </div>

      {/* Right: total + Dettagli link + optional Continue button */}
      <div
        style={{
          display: "flex",
          alignItems: "center",
          gap: "20px",
          marginLeft: "40px",
        }}
      >
        <div style={{ textAlign: "left" }}>
          <div
            style={{
              fontFamily: fontFamilyStyle,
              fontWeight: "700",
              fontSize: "18px",
              color: "#111",
            }}
          >
            {translate("Totale")}:&nbsp;
            <strong>
              {totalPrice.toFixed(2)}&nbsp;{currency || "€"}
            </strong>
          </div>
          {onPriceDetailClick && (
            <div
              onClick={onPriceDetailClick}
              style={{
                fontFamily: fontFamilyStyle,
                fontSize: "12px",
                color: "#111",
                textDecoration: "underline",
                cursor: "pointer",
              }}
            >
              {priceDetailsText || translate("Price details")}
            </div>
          )}
        </div>

        {showContinueButton && (
          <AppButton
            type={onContinue ? "button" : "submit"}
            form={!onContinue ? formId : undefined}
            onClick={onContinue}
            loading={isSaving}
            style={continueButtonStyle}
          >
            <span
              style={{
                fontFamily: fontFamilyStyle,
                color: "#fff",
                fontWeight: "600",
              }}
            >
              {translate("Continue1")}
            </span>
          </AppButton>
        )}
      </div>
    </div>
  );
};

export default GretaHeader;
